import { useEffect, useState } from "react";
import styles from "./PointsLoader.module.css";

type Props = {
  size?: number;
  gap?: number;
  dark?: boolean;
  visible?: boolean;
  delay?: boolean;
  delayMs?: number;
};

export default function PointsLoader(props: Props) {
  const { size = 5, gap = 6, dark = false, visible = true, delay = false, delayMs = 200 } = props;

  const [isVisible, setIsVisible] = useState(!delay);

  useEffect(() => {
    if (!delay) return;

    const timer = setTimeout(() => {
      setIsVisible(true);
    }, delayMs);

    return () => clearTimeout(timer);
  }, [delay, delayMs]);

  if (!visible || !isVisible) return null;

  return (
    <div className={styles.container} style={{ height: size * 2, gap: `${gap}px` }}>
      {[1, 2, 3].map((_, index) => (
        <span
          key={index}
          className={`${styles.circle} ${dark ? styles.dark : styles.light}`}
          style={{ width: `${size}px`, height: `${size}px` }}
        />
      ))}
    </div>
  );
}
